<template>
  <div class="max-w-7xl md:px-8 mx-auto pb-6 lg:pb-10">
    <!-- Sayfa Başlığı -->
    <div class="py-6 px-6 md:px-0">
      <h1 class="text-2xl font-semibold text-gray-900">
        <slot name="title" />
      </h1>
    </div>

    <!-- Ana Grid -->
    <div class="lg:grid lg:grid-cols-12 lg:gap-8">
      <!-- Sol Menü -->
      <aside class="lg:col-span-3 px-6 md:px-0">
        <nav class="space-y-1">
          <UButton v-for="item in menuItems" :key="item.to" :to="item.to" :icon="item.icon"
            :variant="isActive(item.to) ? 'soft' : 'ghost'" :color="isActive(item.to) ? 'orange' : 'gray'"
            class="w-full justify-start">
            {{ item.label }}
          </UButton>
        </nav>
      </aside>

      <!-- Sağ İçerik -->
      <main class="lg:col-span-9 mt-6 lg:mt-0">
        <slot />
      </main>
    </div>
  </div>
</template>

<script setup>
const route = useRoute()

const menuItems = [
  {
    label: 'Siparişlerim',
    to: '/hesap/siparislerim',
    icon: 'i-heroicons-shopping-bag'
  },
  {
    label: 'Adreslerim',
    to: '/hesap/adreslerim',
    icon: 'i-heroicons-map-pin'
  },
  {
    label: 'Favorilerim',
    to: '/hesap/favorilerim',
    icon: 'i-heroicons-heart'
  },
  {
    label: 'Hesap Bilgilerim',
    to: '/hesap/bilgilerim',
    icon: 'i-heroicons-user'
  }
]

const isActive = (path) => {
  return route.path === path
}
</script>
